/**
 * Google API Async Thunks
 * All async actions for Google API operations (email, attachments)
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as googleApi from '../api/googleApi';

/**
 * Send email
 */
export const sendEmailThunk = createAsyncThunk(
  'google/sendEmail',
  async ({ formData }, { rejectWithValue }) => {
    try {
      const data = await googleApi.sendEmail(formData);
      return data;
    } catch (error) {
      console.error('Error sending email:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Upload attachment
 */
export const uploadAttachmentThunk = createAsyncThunk(
  'google/uploadAttachment',
  async ({ leadId, formData }, { rejectWithValue }) => {
    try {
      const data = await googleApi.uploadAttachment(leadId, formData);
      return data;
    } catch (error) {
      console.error('Error uploading attachment:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Delete attachment
 */
export const deleteAttachmentThunk = createAsyncThunk(
  'google/deleteAttachment',
  async ({ leadId, fileId }, { rejectWithValue }) => {
    try {
      const data = await googleApi.deleteAttachment(leadId, fileId);
      return data;
    } catch (error) {
      console.error('Error deleting attachment:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Rename attachment
 */
export const renameAttachmentThunk = createAsyncThunk(
  'google/renameAttachment',
  async (data, { rejectWithValue }) => {
    try {
      const result = await googleApi.renameAttachment(data);
      return result;
    } catch (error) {
      console.error('Error renaming attachment:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
